/* ============================================================
   LF PRIVÉ · Ficha de producto (estilo Scent) · v1
   Elementos: <scent-product>, <scent-fbt>, <scent-recommendations>,
   <scent-carousel>, <scent-bottom-nav>.
   Usa el <product-form> de Dawn para agregar al carrito, así siguen
   funcionando la notificación del carrito y «Pago contra entrega».
   ============================================================ */
(function () {
  'use strict';

  if (window.__lfScentLoaded) return;
  window.__lfScentLoaded = true;

  /* ---------------- utilidades ---------------- */
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  function reduceMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }
  function isDesktop() {
    return !!(window.matchMedia && window.matchMedia('(min-width: 990px)').matches);
  }
  function onPageLoad(fn) {
    if (document.readyState === 'complete') fn();
    else window.addEventListener('load', fn, { once: true });
  }
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }
  function fmtSize(t) {
    t = String(t == null ? '' : t);
    return /ml/i.test(t) ? t.toUpperCase().replace(/\s*ML\b/, ' ML').trim() : t;
  }
  function mlOf(title) {
    var t = String(title || '').toLowerCase().replace(/\s/g, '');
    if (t.indexOf('ml') === -1) return 0;
    var n = parseFloat(t.split('ml')[0].replace(',', '.'));
    return isFinite(n) && n > 0 ? n : 0;
  }
  function toCents(p) {
    if (typeof p === 'number') return Math.round(p);
    if (typeof p === 'string') return p.indexOf('.') > -1 ? Math.round(parseFloat(p) * 100) : parseInt(p, 10) || 0;
    return 0;
  }
  function sizedImage(url, w) {
    if (!url) return null;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function shortTitle(t) {
    return String(t || '').replace(/\s+decant\s*$/i, '').trim();
  }

  /* Formato de dinero de Shopify ({{amount}}, {{amount_no_decimals}}, etc.) */
  function formatMoney(cents, format) {
    cents = toCents(cents);
    var fmt = format || 'S/ {{amount}}';
    var re = /\{\{\s*(\w+)\s*\}\}/;
    function delim(n, precision, thousands, decimal) {
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      var parts = (n / 100).toFixed(precision).split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var m = fmt.match(re);
    var value;
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': value = delim(cents, 0); break;
      case 'amount_with_comma_separator': value = delim(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = delim(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = delim(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = delim(cents, 0, ' ', ''); break;
      case 'amount_with_space_separator': value = delim(cents, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': value = delim(cents, 2, ' ', '.'); break;
      default: value = delim(cents, 2);
    }
    return fmt.replace(re, value);
  }

  /* Bloqueo de scroll y capas (visor, ventanas) */
  var lockCount = 0;
  function lockScroll() { if (lockCount++ === 0) document.documentElement.classList.add('sp-lock'); }
  function unlockScroll() {
    if (lockCount > 0 && --lockCount === 0) document.documentElement.classList.remove('sp-lock');
  }
  function focusables(root) {
    return $$('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea, [tabindex]:not([tabindex="-1"])', root)
      .filter(function (el) { return el.offsetParent !== null || el === document.activeElement; });
  }
  function openLayer(el, focusEl) {
    if (!el || !el.hidden) return;
    el.hidden = false;
    lockScroll();
    el._prevFocus = document.activeElement;
    el._keys = function (e) {
      if (e.key === 'Escape') { closeLayer(el); return; }
      if (e.key !== 'Tab') return;
      var f = focusables(el);
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    };
    document.addEventListener('keydown', el._keys);
    requestAnimationFrame(function () {
      var target = focusEl || focusables(el)[0];
      if (target) target.focus({ preventScroll: true });
    });
  }
  function closeLayer(el) {
    if (!el || el.hidden) return;
    el.hidden = true;
    unlockScroll();
    document.removeEventListener('keydown', el._keys);
    if (typeof el._onClose === 'function') el._onClose();
    if (el._prevFocus && el._prevFocus.focus) el._prevFocus.focus({ preventScroll: true });
  }

  var ICON = {
    plus: '<svg class="sp-icon" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M12 5v14M5 12h14"/></svg>',
    check: '<svg class="sp-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M20 6 9 17l-5-5"/></svg>',
    chevron: '<svg class="sp-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="m6 9 6 6 6-6"/></svg>'
  };

  function define(name, cls) {
    if (window.customElements && !customElements.get(name)) customElements.define(name, cls);
  }

  /* ============================================================
     <scent-product> · ficha principal
     ============================================================ */
  class ScentProduct extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      var dataEl = $('script[data-sp-data]', this);
      try { this.data = JSON.parse(dataEl.textContent); } catch (e) { console.error('[LF] No se pudieron leer los datos de la ficha', e); return; }

      this.variants = this.data.variants || [];
      this.variant = this.find(this.data.currentVariantId) || this.variants[0] || null;
      this.selected = this.variant ? this.variant.options.slice() : [];
      this.form = $('form[data-type="add-to-cart-form"]', this);
      this.input = $('[data-sp-variant-input]', this);
      this.atc = $('[data-sp-atc]', this);
      this.atcText = $('[data-sp-atc-text]', this);

      this.initOptions();
      this.initQty();
      this.initGallery();
      this.initLightbox();
      this.initSticky();
      this.initNotify();
      this.initStarsLinks();
      if (this.variant) this.renderSticky(this.variant);
    }

    money(cents) { return formatMoney(cents, this.data.moneyFormat); }
    find(id) {
      for (var i = 0; i < this.variants.length; i++) if (String(this.variants[i].id) === String(id)) return this.variants[i];
      return null;
    }
    findByOptions(opts) {
      return this.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      }) || null;
    }

    /* ---------- tamaños ---------- */
    initOptions() {
      var self = this;
      this.groups = $$('[data-sp-option]', this);
      this.groups.forEach(function (group) {
        var idx = Number(group.dataset.spOption);
        group.addEventListener('click', function (e) {
          var btn = e.target.closest('[data-sp-value]');
          if (!btn || !group.contains(btn)) return;
          self.selectOption(idx, btn.dataset.spValue);
        });
        group.addEventListener('keydown', function (e) {
          if (['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp'].indexOf(e.key) === -1) return;
          var btns = $$('[data-sp-value]', group);
          var i = btns.indexOf(document.activeElement);
          if (i < 0) return;
          e.preventDefault();
          var dir = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : -1;
          var next = btns[(i + dir + btns.length) % btns.length];
          next.focus();
          self.selectOption(idx, next.dataset.spValue);
        });
      });
    }

    selectOption(idx, value) {
      var opts = this.selected.slice();
      opts[idx] = value;
      var v = this.findByOptions(opts);
      if (!v) {
        v = this.variants.find(function (x) { return x.options[idx] === value && x.available; }) ||
            this.variants.find(function (x) { return x.options[idx] === value; });
        if (!v) return;
      }
      this.selected = v.options.slice();
      this.setVariant(v);
    }

    setVariant(v) {
      var changed = !this.variant || this.variant.id !== v.id;
      this.variant = v;
      this.render();
      if (v.media) this.goToMedia(v.media);
      if (changed) {
        this.updateUrl(v);
        this.dispatchEvent(new CustomEvent('scent:variant-change', {
          bubbles: true,
          detail: { productId: this.data.productId, variant: v }
        }));
      }
    }

    render() {
      var self = this, v = this.variant;
      if (!v) return;

      this.groups.forEach(function (group) {
        var idx = Number(group.dataset.spOption);
        $$('[data-sp-value]', group).forEach(function (btn) {
          var val = btn.dataset.spValue;
          var active = self.selected[idx] === val;
          btn.classList.toggle('is-active', active);
          btn.setAttribute('aria-checked', active ? 'true' : 'false');
          btn.tabIndex = active ? 0 : -1;
          var o = self.selected.slice();
          o[idx] = val;
          var m = self.findByOptions(o);
          btn.classList.toggle('is-soldout', !m || !m.available);
        });
        var label = $('[data-sp-option-value]', group);
        if (label) label.textContent = fmtSize(self.selected[idx] || '');
      });

      if (this.input && String(this.input.value) !== String(v.id)) {
        this.input.value = v.id;
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      var now = $('[data-sp-price-now]', this);
      var was = $('[data-sp-price-was]', this);
      if (now) now.textContent = this.money(v.price);
      if (was) {
        var sale = v.compare > v.price;
        was.hidden = !sale;
        if (sale) was.textContent = this.money(v.compare);
      }

      var saleBadge = $('[data-sp-sale]', this);
      if (saleBadge) saleBadge.hidden = !(v.compare > v.price);

      var soldout = $('[data-sp-soldout]', this);
      if (soldout) soldout.hidden = !!v.available;
      var best = $('[data-sp-bestseller]', this);
      if (best) best.hidden = !v.available;

      this.renderUsage(v);

      if (this.atc) {
        this.atc.disabled = !v.available;
        this.atc.removeAttribute('aria-disabled');
        if (this.atcText) this.atcText.textContent = v.available ? this.data.atcLabel : this.data.soldOutLabel;
      }
      var notifyLink = $('[data-sp-notify-open]', this);
      if (notifyLink) notifyLink.hidden = !!v.available;

      var nv = $('[data-sp-notify-variant]', this);
      if (nv) nv.value = v.title;
      var nid = $('[data-sp-notify-variant-id]', this);
      if (nid) nid.value = v.id;
      var ns = $('[data-sp-notify-size]', this);
      if (ns) ns.textContent = fmtSize(v.title);

      $$('[data-sp-table-row]', this).forEach(function (row) {
        row.classList.toggle('is-current', row.dataset.spTableRow === String(v.id));
      });

      this.renderSticky(v);
    }

    renderUsage(v) {
      var box = $('[data-sp-usage]', this);
      if (!box) return;
      var u = this.data.usage, ml = Number(v.ml) || 0;
      if (!u || ml <= 0) { box.hidden = true; return; }
      var tier = u.tiers.find(function (t) { return ml <= t.max; }) || u.tiers[u.tiers.length - 1];
      var a = Math.round(ml * u.spmMin), b = Math.round(ml * u.spmMax);
      $('[data-sp-usage-title]', box).textContent = tier.title;
      $('[data-sp-usage-sprays]', box).textContent = (a === b ? a : a + '–' + b) + ' ' + u.word;
      $('[data-sp-usage-text]', box).textContent = tier.text;
      box.hidden = false;
    }

    updateUrl(v) {
      if (!this.data.updateUrl || !window.history || !window.history.replaceState) return;
      if (window.Shopify && window.Shopify.designMode) return;
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState(window.history.state, '', url.toString());
      } catch (e) { /* sin cambios en la URL */ }
    }

    /* ---------- cantidad ---------- */
    initQty() {
      var wrap = $('[data-sp-qty]', this);
      if (!wrap) return;
      var input = $('input', wrap);
      var minus = $('[data-sp-qty-btn="minus"]', wrap);
      var plus = $('[data-sp-qty-btn="plus"]', wrap);
      function limits() {
        return {
          min: parseInt(input.min, 10) || 1,
          max: input.max ? parseInt(input.max, 10) : Infinity,
          step: parseInt(input.step, 10) || 1
        };
      }
      function sync() {
        var l = limits(), val = parseInt(input.value, 10) || l.min;
        if (minus) minus.disabled = val <= l.min;
        if (plus) plus.disabled = val >= l.max;
      }
      wrap.addEventListener('click', function (e) {
        var b = e.target.closest('[data-sp-qty-btn]');
        if (!b) return;
        var l = limits(), cur = parseInt(input.value, 10) || l.min;
        var next = cur + (b.dataset.spQtyBtn === 'plus' ? l.step : -l.step);
        next = Math.max(l.min, Math.min(l.max, next));
        if (next !== cur) {
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        sync();
      });
      input.addEventListener('change', function () {
        var l = limits(), val = parseInt(input.value, 10);
        if (isNaN(val)) val = l.min;
        input.value = Math.max(l.min, Math.min(l.max, val));
        sync();
      });
      sync();
    }

    /* ---------- galería ---------- */
    initGallery() {
      var self = this;
      var g = $('[data-sp-gallery]', this);
      if (!g) return;
      this.track = $('[data-sp-track]', g);
      this.slides = $$('[data-sp-slide]', this.track);
      this.thumbs = $$('[data-sp-thumb]', g);
      this.dots = $$('.sp-dot', g);
      this.zoomBtn = $('[data-sp-zoom]', g);
      this.index = 0;
      this._target = null;

      this.thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () { self.goTo(i); });
      });

      var ticking = false;
      this.track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { ticking = false; self.syncIndex(); });
      }, { passive: true });

      this.track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); self.goTo(self.index + 1); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); self.goTo(self.index - 1); }
      });

      this.slides.forEach(function (s, i) {
        if (s.dataset.kind !== 'image') return;
        s.addEventListener('click', function () {
          if (self._dragMoved) return;
          self.openLightbox(i);
        });
      });
      if (this.zoomBtn) this.zoomBtn.addEventListener('click', function () { self.openLightbox(self.index); });

      this.initDrag();

      var start = Number(g.dataset.startMedia || 0);
      if (start) this.goToMedia(start, false);
      else this.setIndex(0);

      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () { self.goTo(self.index, false); }, 120);
      });
    }

    initDrag() {
      var self = this, tr = this.track;
      var down = false, moved = false, startX = 0, startLeft = 0, startIndex = 0;
      tr.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        down = true; moved = false; self._dragMoved = false;
        startX = e.clientX; startLeft = tr.scrollLeft; startIndex = self.index;
      });
      window.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (!moved && Math.abs(dx) > 6) {
          moved = true; self._dragMoved = true;
          tr.classList.add('is-dragging');
        }
        if (moved) tr.scrollLeft = startLeft - dx;
      });
      window.addEventListener('pointerup', function (e) {
        if (!down) return;
        down = false;
        if (!moved) return;
        tr.classList.remove('is-dragging');
        var dx = e.clientX - startX, i = startIndex;
        if (Math.abs(dx) > tr.clientWidth * 0.12) i += dx < 0 ? 1 : -1;
        self.goTo(i);
        setTimeout(function () { self._dragMoved = false; }, 60);
      });
    }

    goTo(i, smooth) {
      if (!this.track || !this.slides.length) return;
      i = Math.max(0, Math.min(this.slides.length - 1, i));
      var self = this;
      this._target = i;
      clearTimeout(this._targetTimer);
      this._targetTimer = setTimeout(function () { self._target = null; self.syncIndex(); }, 700);
      this.track.scrollTo({ left: this.slides[i].offsetLeft, behavior: smooth === false || reduceMotion() ? 'auto' : 'smooth' });
      this.setIndex(i);
    }

    goToMedia(mediaId, smooth) {
      if (!mediaId || !this.slides) return;
      var i = this.slides.findIndex(function (s) { return s.dataset.mediaId === String(mediaId); });
      if (i >= 0) this.goTo(i, smooth);
    }

    syncIndex() {
      if (!this.track) return;
      var i = Math.round(this.track.scrollLeft / (this.track.clientWidth || 1));
      if (this._target !== null) {
        if (i !== this._target) return;
        this._target = null;
      }
      if (i !== this.index) this.setIndex(i);
    }

    setIndex(i) {
      this.index = i;
      this.thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      this.dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      var s = this.slides[i];
      if (this.zoomBtn) this.zoomBtn.hidden = !s || s.dataset.kind !== 'image';
      var t = this.thumbs[i];
      if (t && t.parentElement && t.parentElement.scrollWidth > t.parentElement.clientWidth) {
        var p = t.parentElement;
        p.scrollTo({ left: t.offsetLeft - (p.clientWidth - t.clientWidth) / 2, behavior: reduceMotion() ? 'auto' : 'smooth' });
      }
      this.slides.forEach(function (sl, k) {
        if (k === i) return;
        $$('video', sl).forEach(function (vid) { try { vid.pause(); } catch (e) { /* nada */ } });
      });
    }

    /* ---------- visor de imágenes ---------- */
    initLightbox() {
      var self = this;
      this.lb = $('[data-sp-lightbox]', this);
      if (!this.lb) return;
      this.lbTrack = $('[data-sp-lb-track]', this.lb);
      this.lbCount = $('[data-sp-lb-count]', this.lb);
      this.lbIndex = 0;
      $('[data-sp-lb-close]', this.lb).addEventListener('click', function () { closeLayer(self.lb); });
      $('[data-sp-lb-prev]', this.lb).addEventListener('click', function () { self.lbGo(self.lbIndex - 1); });
      $('[data-sp-lb-next]', this.lb).addEventListener('click', function () { self.lbGo(self.lbIndex + 1); });
      this.lb.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') self.lbGo(self.lbIndex + 1);
        else if (e.key === 'ArrowLeft') self.lbGo(self.lbIndex - 1);
      });
      var ticking = false;
      this.lbTrack.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          var i = Math.round(self.lbTrack.scrollLeft / (self.lbTrack.clientWidth || 1));
          if (i !== self.lbIndex) { self.lbIndex = i; self.lbRenderCount(); self.lbResetZoom(); }
        });
      }, { passive: true });
      this.lb._onClose = function () { self.lbResetZoom(); };
    }

    buildLightbox() {
      if (this.lbBuilt) return;
      this.lbBuilt = true;
      var self = this;
      this.lbMap = [];
      var frag = document.createDocumentFragment();
      (this.slides || []).forEach(function (s, i) {
        if (s.dataset.kind !== 'image' || !s.dataset.full) return;
        self.lbMap.push(i);
        var wrap = document.createElement('div');
        wrap.className = 'sp-lightbox__slide';
        var img = document.createElement('img');
        img.className = 'sp-lightbox__img';
        img.alt = s.dataset.alt || '';
        img.decoding = 'async';
        img.loading = 'lazy';
        img.draggable = false;
        img.src = s.dataset.full;
        img.addEventListener('click', function (e) { self.lbToggleZoom(wrap, e); });
        img.addEventListener('mousemove', function (e) { self.lbPan(wrap, img, e); });
        wrap.appendChild(img);
        frag.appendChild(wrap);
      });
      this.lbTrack.appendChild(frag);
    }

    openLightbox(slideIndex) {
      if (!this.lb || !this.slides) return;
      this.buildLightbox();
      if (!this.lbMap.length) return;
      var k = this.lbMap.indexOf(slideIndex);
      if (k < 0) k = 0;
      openLayer(this.lb, $('[data-sp-lb-close]', this.lb));
      this.lbIndex = k;
      var self = this;
      requestAnimationFrame(function () {
        self.lbTrack.scrollLeft = self.lbTrack.clientWidth * k;
        self.lbRenderCount();
      });
    }

    lbGo(k) {
      var n = this.lbMap ? this.lbMap.length : 0;
      if (!n) return;
      k = (k + n) % n;
      this.lbResetZoom();
      this.lbIndex = k;
      this.lbTrack.scrollTo({ left: this.lbTrack.clientWidth * k, behavior: reduceMotion() ? 'auto' : 'smooth' });
      this.lbRenderCount();
    }
    lbRenderCount() {
      if (this.lbCount && this.lbMap) this.lbCount.textContent = (this.lbIndex + 1) + ' / ' + this.lbMap.length;
    }
    lbToggleZoom(wrap, e) {
      var on = !wrap.classList.contains('is-zoomed');
      this.lbResetZoom();
      if (on) {
        wrap.classList.add('is-zoomed');
        this.lbPan(wrap, $('img', wrap), e);
      }
    }
    lbPan(wrap, img, e) {
      if (!wrap.classList.contains('is-zoomed')) return;
      var r = wrap.getBoundingClientRect();
      var x = Math.max(0, Math.min(100, ((e.clientX - r.left) / r.width) * 100));
      var y = Math.max(0, Math.min(100, ((e.clientY - r.top) / r.height) * 100));
      img.style.transformOrigin = x + '% ' + y + '%';
    }
    lbResetZoom() {
      if (!this.lb) return;
      $$('.sp-lightbox__slide.is-zoomed', this.lb).forEach(function (w) { w.classList.remove('is-zoomed'); });
    }

    /* ---------- barra fija ---------- */
    initSticky() {
      var self = this;
      this.sticky = $('[data-sp-sticky]', this);
      if (!this.sticky || !this.form) return;
      this.stickyBtn = $('[data-sp-sticky-add]', this.sticky);
      var anchor = this.atc || this.form;
      var pastBuy = false, nearFooter = false;

      function update() {
        var want = isDesktop() ? self.dataset.stickyDesktop === 'true' : self.dataset.stickyMobile === 'true';
        var show = want && pastBuy && !nearFooter;
        self.sticky.classList.toggle('is-visible', show);
        self.sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (show) self.sticky.removeAttribute('inert');
        else self.sticky.setAttribute('inert', '');
      }

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          var en = entries[0];
          pastBuy = !en.isIntersecting && en.boundingClientRect.top < 0;
          update();
        }).observe(anchor);
        var footer = document.querySelector('.shopify-section-group-footer-group') || document.querySelector('footer');
        if (footer) {
          new IntersectionObserver(function (entries) {
            nearFooter = entries[0].isIntersecting;
            update();
          }).observe(footer);
        }
      }
      window.addEventListener('resize', update);

      if (this.stickyBtn) {
        this.stickyBtn.addEventListener('click', function () {
          if (!self.variant || !self.variant.available) { self.openNotify(); return; }
          if (self.form.requestSubmit && self.atc) self.form.requestSubmit(self.atc);
          else if (self.atc) self.atc.click();
        });
      }
    }

    renderSticky(v) {
      if (!this.sticky) return;
      var vEl = $('[data-sp-sticky-variant]', this.sticky);
      if (vEl) vEl.textContent = fmtSize(v.title);
      var pEl = $('[data-sp-sticky-price]', this.sticky);
      if (pEl) pEl.textContent = this.money(v.price);
      var img = $('[data-sp-sticky-img]', this.sticky);
      if (img && v.image && img.getAttribute('src') !== v.image) {
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = v.image;
      }
      if (this.stickyBtn) this.stickyBtn.textContent = v.available ? this.data.atcLabel : this.data.notifyShort;
    }

    /* ---------- avísame cuando esté disponible ---------- */
    initNotify() {
      var self = this;
      this.notify = $('[data-sp-notify]', this);
      if (!this.notify) return;
      $$('[data-sp-notify-open]', this).forEach(function (b) {
        b.addEventListener('click', function () { self.openNotify(); });
      });
      $$('[data-sp-modal-close]', this.notify).forEach(function (b) {
        b.addEventListener('click', function () { closeLayer(self.notify); });
      });
      this.notify.addEventListener('click', function (e) { if (e.target === self.notify) closeLayer(self.notify); });

      var form = $('form', this.notify);
      var msg = $('[data-sp-notify-msg]', this.notify);
      if (form) {
        form.addEventListener('submit', function (e) {
          var key = self.klaviyoKey();
          if (!key || !self.variant) return; /* sin Klaviyo: el formulario llega al correo de la tienda */
          e.preventDefault();
          var email = ($('input[type="email"]', form) || {}).value || '';
          var btn = $('[type="submit"]', form);
          if (btn) btn.disabled = true;
          if (msg) { msg.classList.remove('is-error'); msg.textContent = ''; }
          fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(key), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/vnd.api+json',
              'Accept': 'application/vnd.api+json',
              'revision': '2024-10-15'
            },
            body: JSON.stringify({
              data: {
                type: 'back-in-stock-subscription',
                attributes: {
                  profile: { data: { type: 'profile', attributes: { email: email } } },
                  channels: ['EMAIL']
                },
                relationships: {
                  variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + self.variant.id } }
                }
              }
            })
          }).then(function (r) {
            if (!r.ok) throw new Error('HTTP ' + r.status);
            if (msg) msg.textContent = self.data.notifySuccess;
            form.reset();
          }).catch(function () {
            /* Si Klaviyo no responde, enviamos el formulario de contacto de siempre. */
            form.submit();
          }).then(function () {
            if (btn) btn.disabled = false;
          });
        });
      }
      if ($('[data-sp-notify-posted]', this.notify)) this.openNotify();
    }

    openNotify() {
      if (!this.notify) return;
      openLayer(this.notify, $('input[type="email"]', this.notify));
    }

    klaviyoKey() {
      if (this.data.klaviyoKey) return this.data.klaviyoKey;
      var s = document.querySelector('script[src*="klaviyo.com/onsite/js/"]');
      if (!s) return '';
      var m = s.src.match(/company_id=([A-Za-z0-9]+)/) || s.src.match(/onsite\/js\/([A-Za-z0-9]{6})\/klaviyo\.js/);
      return m ? m[1] : '';
    }

    /* ---------- estrellas → reseñas ---------- */
    initStarsLinks() {
      $$('[data-sp-stars-link]', this).forEach(function (a) {
        a.addEventListener('click', function (e) {
          var target = document.getElementById('sp-reviews') || document.querySelector('.jdgm-rev-widg, #judgeme_product_reviews');
          if (!target) return;
          e.preventDefault();
          target.scrollIntoView({ behavior: reduceMotion() ? 'auto' : 'smooth', block: 'start' });
        });
      });
    }
  }

  /* ============================================================
     <scent-fbt> · Comprados juntos frecuentemente
     ============================================================ */
  class ScentFbt extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      var self = this;
      try { this.data = JSON.parse($('script[data-sp-fbt-data]', this).textContent); } catch (e) { return; }
      this.body = $('[data-sp-fbt-body]', this);
      this.items = [];
      document.addEventListener('scent:variant-change', function (e) {
        if (!e.detail || String(e.detail.productId) !== String(self.data.product.id) || !self.items.length) return;
        var main = self.items[0];
        var v = main.product.variants.find(function (x) { return String(x.id) === String(e.detail.variant.id); });
        if (v) { main.variant = v; self.paint(); }
      });
      onPageLoad(function () { self.load(); });
    }

    money(c) { return formatMoney(c, this.data.moneyFormat); }

    /* Pide a Shopify esta misma sección con los productos sugeridos ya procesados
       (nombre corto, tamaños y precios). Primero los complementarios; si faltan, los relacionados. */
    fetchRecs(intent) {
      var d = this.data;
      var url = d.url + '?section_id=' + encodeURIComponent(d.sectionId) + '&product_id=' + d.product.id +
        '&limit=' + Math.min(10, d.limit + 4) + '&intent=' + intent;
      return fetch(url)
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (!html) return [];
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var node = doc.querySelector('script[data-sp-fbt-recs]');
          if (!node) return [];
          try { return JSON.parse(node.textContent) || []; } catch (e) { return []; }
        })
        .catch(function () { return []; });
    }

    load() {
      var self = this, d = this.data, found = [];
      var intents = d.intents.slice();
      function next() {
        if (!intents.length || found.length >= d.limit) return Promise.resolve();
        return self.fetchRecs(intents.shift()).then(function (list) {
          list.forEach(function (p) {
            if (found.length >= d.limit) return;
            if (String(p.id) === String(d.product.id) || p.available === false) return;
            if (found.some(function (f) { return String(f.id) === String(p.id); })) return;
            if (!(p.variants || []).some(function (v) { return v.available; })) return;
            found.push(self.normalize(p));
          });
        }).then(next);
      }
      next().then(function () {
        if (!found.length) { self.empty(); return; }
        var main = {
          product: d.product,
          variant: d.product.variants.find(function (v) { return String(v.id) === String(d.currentVariantId); }) || d.product.variants[0],
          checked: true,
          main: true
        };
        var mainMl = main.variant ? main.variant.ml : 0;
        self.items = [main].concat(found.map(function (p) {
          return { product: p, variant: self.pickVariant(p, mainMl), checked: true };
        }));
        self.paint(true);
      });
    }

    normalize(p) {
      var img = p.image || (p.featured_image ? (typeof p.featured_image === 'string' ? sizedImage(p.featured_image, 300) : sizedImage(p.featured_image.src, 300)) : null);
      return {
        id: p.id,
        title: shortTitle(p.title),
        url: p.url || ('/products/' + p.handle),
        image: img,
        variants: (p.variants || []).map(function (v) {
          return {
            id: v.id,
            title: v.title,
            price: toCents(v.price),
            available: v.available !== false,
            ml: typeof v.ml === 'number' ? v.ml : mlOf(v.title)
          };
        })
      };
    }

    pickVariant(p, mainMl) {
      var avail = p.variants.filter(function (v) { return v.available; });
      if (!avail.length) return p.variants[0];
      if (this.data.defaultSize === 'same' && mainMl) {
        var same = avail.find(function (v) { return v.ml === mainMl; });
        if (same) return same;
      }
      return avail.slice().sort(function (a, b) { return (a.ml || 9999) - (b.ml || 9999) || a.price - b.price; })[0];
    }

    empty() {
      if (window.Shopify && window.Shopify.designMode) {
        this.hidden = false;
        this.body.innerHTML = '<p class="sp-fbt__empty">' + esc(this.data.strings.empty) + '</p>';
        return;
      }
      var sec = this.closest('.shopify-section');
      if (sec) sec.classList.add('sp-hidden');
      this.hidden = true;
    }

    template() {
      var s = this.data.strings;
      var imgs = this.items.map(function (it, i) {
        return (i ? '<span class="sp-fbt__plus" aria-hidden="true">' + ICON.plus + '</span>' : '') +
          '<a class="sp-fbt__img" href="' + esc(it.product.url) + '" data-fbt-img="' + i + '" aria-label="' + esc(it.product.title) + '">' +
          (it.product.image ? '<img src="' + esc(it.product.image) + '" alt="" loading="lazy" width="150" height="150">' : '') +
          '</a>';
      }).join('');
      var list = this.items.map(function (it, i) {
        var many = it.product.variants.length > 1;
        var opts = it.product.variants.map(function (v) {
          return '<option value="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' +
            esc(fmtSize(v.title)) + (v.available ? '' : ' · ' + esc(s.soldOut)) + '</option>';
        }).join('');
        return '<li class="sp-fbt__item">' +
          '<div class="sp-fbt__row">' +
            '<label class="sp-fbt__check"><input type="checkbox" data-fbt-check="' + i + '"' + (it.checked ? ' checked' : '') + '>' +
            '<span class="sp-fbt__box" aria-hidden="true">' + ICON.check + '</span>' +
            '<span class="sp-fbt__name">' + esc(it.product.title) + '</span></label>' +
            '<span class="sp-fbt__price" data-fbt-price="' + i + '"></span>' +
          '</div>' +
          (many ? '<div class="sp-select"><select data-fbt-variant="' + i + '" aria-label="' + esc(s.sizeFor + ' ' + it.product.title) + '">' + opts + '</select>' + ICON.chevron + '</div>' : '') +
        '</li>';
      }).join('');
      return '<div class="sp-fbt__inner">' +
        '<div class="sp-fbt__imgs">' + imgs + '</div>' +
        '<div class="sp-fbt__total">' +
          '<p class="sp-fbt__sum"><strong>' + esc(s.total) + '</strong><span data-fbt-total></span></p>' +
          '<button type="button" class="sp-btn sp-btn--dark sp-fbt__btn" data-fbt-add><span data-fbt-add-label>' + esc(s.addAll) + '</span></button>' +
          '<p class="sp-fbt__error" data-fbt-error role="alert" hidden></p>' +
        '</div>' +
        '<ul class="sp-fbt__list" role="list">' + list + '</ul>' +
      '</div>';
    }

    paint(first) {
      var self = this, s = this.data.strings;
      if (first || !this._painted) {
        this.body.innerHTML = this.template();
        this._painted = true;
        this.bind();
        var sec = this.closest('.shopify-section');
        if (sec) sec.classList.remove('sp-hidden');
        this.hidden = false;
      }
      this.items.forEach(function (it, i) {
        var price = $('[data-fbt-price="' + i + '"]', self.body);
        if (price) price.textContent = self.money(it.variant ? it.variant.price : 0);
        var sel = $('[data-fbt-variant="' + i + '"]', self.body);
        if (sel && it.variant) sel.value = String(it.variant.id);
        var img = $('[data-fbt-img="' + i + '"]', self.body);
        if (img) img.classList.toggle('is-off', !it.checked);
        var cb = $('[data-fbt-check="' + i + '"]', self.body);
        if (cb) cb.checked = it.checked;
      });
      var chosen = this.items.filter(function (it) { return it.checked && it.variant && it.variant.available; });
      var total = chosen.reduce(function (sum, it) { return sum + it.variant.price; }, 0);
      $('[data-fbt-total]', this.body).textContent = this.money(total);
      var btn = $('[data-fbt-add]', this.body);
      btn.disabled = chosen.length === 0;
      var label = chosen.length === this.items.length ? s.addAll : (chosen.length === 1 ? s.addOne : s.addSome.replace('{n}', chosen.length));
      $('[data-fbt-add-label]', btn).textContent = label;
    }

    bind() {
      if (this._bound) return;
      this._bound = true;
      var self = this;
      this.body.addEventListener('change', function (e) {
        var cb = e.target.closest('[data-fbt-check]');
        if (cb) {
          self.items[Number(cb.dataset.fbtCheck)].checked = cb.checked;
          self.paint();
          return;
        }
        var sel = e.target.closest('[data-fbt-variant]');
        if (sel) {
          var it = self.items[Number(sel.dataset.fbtVariant)];
          var v = it.product.variants.find(function (x) { return String(x.id) === sel.value; });
          if (v) { it.variant = v; self.paint(); }
        }
      });
      this.body.addEventListener('click', function (e) {
        if (e.target.closest('[data-fbt-add]')) self.addAll();
      });
    }

    addAll() {
      var self = this;
      var btn = $('[data-fbt-add]', this.body), err = $('[data-fbt-error]', this.body);
      var items = this.items
        .filter(function (it) { return it.checked && it.variant && it.variant.available; })
        .map(function (it) { return { id: it.variant.id, quantity: 1 }; });
      if (!items.length || btn.disabled) return;
      err.hidden = true;
      btn.disabled = true;
      btn.classList.add('is-loading');

      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var body = { items: items };
      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.sections = cart.getSectionsToRender().map(function (x) { return x.id; });
        body.sections_url = window.location.pathname;
      }
      var addUrl = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';

      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          var j = res.j || {};
          if (!res.ok || j.status) throw new Error(j.description || j.message || self.data.strings.error);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'scent-fbt', productVariantId: items[0].id, cartData: j });
          }
          if (cart && typeof cart.renderContents === 'function' && j.sections) {
            var first = (j.items && j.items[0]) || {};
            if (typeof cart.setActiveElement === 'function') cart.setActiveElement(btn);
            cart.renderContents(Object.assign({}, j, { key: first.key, id: first.id }));
            cart.classList.remove('is-empty');
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
        })
        .catch(function (e) {
          err.textContent = (e && e.message) || self.data.strings.error;
          err.hidden = false;
        })
        .then(function () {
          btn.disabled = false;
          btn.classList.remove('is-loading');
        });
    }
  }

  /* ============================================================
     <scent-recommendations> · También podría gustarte
     ============================================================ */
  class ScentRecommendations extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      var self = this;
      if (!this.dataset.url) return;
      onPageLoad(function () {
        fetch(self.dataset.url)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.querySelector('scent-recommendations');
            if (fresh && fresh.querySelector('.sp-card')) {
              self.innerHTML = fresh.innerHTML;
              self.hidden = false;
              var sec = self.closest('.shopify-section');
              if (sec) sec.classList.remove('sp-hidden');
            } else {
              self.hide();
            }
          })
          .catch(function () { self.hide(); });
      });
    }
    hide() {
      if (window.Shopify && window.Shopify.designMode) return;
      var sec = this.closest('.shopify-section');
      if (sec) sec.classList.add('sp-hidden');
    }
  }

  /* ============================================================
     <scent-carousel> · carrusel con flechas
     ============================================================ */
  class ScentCarousel extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      var self = this;
      this.track = $('[data-sp-car-track]', this);
      if (!this.track) return;
      this.prev = $('[data-sp-car-prev]', this);
      this.next = $('[data-sp-car-next]', this);
      function step(dir) {
        var item = self.track.firstElementChild;
        var gap = parseFloat(getComputedStyle(self.track).columnGap) || 0;
        var w = item ? item.getBoundingClientRect().width + gap : self.track.clientWidth;
        self.track.scrollBy({ left: dir * w, behavior: reduceMotion() ? 'auto' : 'smooth' });
      }
      if (this.prev) this.prev.addEventListener('click', function () { step(-1); });
      if (this.next) this.next.addEventListener('click', function () { step(1); });
      var ticking = false;
      function update() {
        ticking = false;
        var max = self.track.scrollWidth - self.track.clientWidth - 2;
        if (self.prev) self.prev.disabled = self.track.scrollLeft <= 2;
        if (self.next) self.next.disabled = self.track.scrollLeft >= max;
        self.classList.toggle('is-static', self.track.scrollWidth <= self.track.clientWidth + 2);
        var media = $('.sp-card__media', self.track);
        if (media && media.offsetHeight) self.style.setProperty('--sp-arrow-top', (media.offsetHeight / 2) + 'px');
      }
      this.track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      }, { passive: true });
      window.addEventListener('resize', update);
      update();
      setTimeout(update, 400);
      onPageLoad(update);
    }
  }

  /* ============================================================
     <scent-bottom-nav> · barra inferior en móvil
     ============================================================ */
  class ScentBottomNav extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      var self = this;
      var menu = $('[data-sp-bnav-menu]', this);
      if (menu) {
        menu.addEventListener('click', function (e) {
          var summary = document.querySelector('header-drawer details > summary, #Details-menu-drawer-container > summary');
          if (!summary) return;
          e.preventDefault();
          var r = summary.getBoundingClientRect();
          if (r.bottom < 0 || r.top > window.innerHeight) {
            window.scrollTo({ top: 0, behavior: 'auto' });
            requestAnimationFrame(function () { summary.click(); });
          } else {
            summary.click();
          }
        });
      }
      this.count = $('[data-sp-bnav-count]', this);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function () { self.refresh(); });
      }
      var here = window.location.pathname.replace(/\/$/, '') || '/';
      $$('a.sp-bnav__item', this).forEach(function (a) {
        var p = (a.getAttribute('href') || '').replace(/\/$/, '') || '/';
        if (p === here) a.setAttribute('aria-current', 'page');
      });
    }
    refresh() {
      var self = this;
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          if (!self.count) return;
          self.count.textContent = c.item_count;
          self.count.dataset.count = c.item_count;
        })
        .catch(function () { /* nada */ });
    }
  }

  define('scent-product', ScentProduct);
  define('scent-fbt', ScentFbt);
  define('scent-recommendations', ScentRecommendations);
  define('scent-carousel', ScentCarousel);
  define('scent-bottom-nav', ScentBottomNav);

  window.LFScent = { formatMoney: formatMoney, version: 1 };
})();
